//Core
import React, { useState } from "react"

//Components
import Carousel from "./Carousel"
import SwipBox from "./SwipBox"
import AnswerBox from "./AnswerBox"

//Styles
import style from "./style.module.scss"
import jump from "jump.js"

//Images
import AppleWallet from "../../images/AppleWallet.png"
import AppleWatch from "../../images/apple-watch.png"

const Index = () => {
  const [activeStep, setActiveStep] = useState(0)
  const [show, setVision] = useState(false)
  const maxSteps = 5

  const toogle = () => {
    setVision(!show)
  }

  const toogleInfo = () => {
    if (!show) {
      setVision(!show)
    } else {
      jump(".set_up", {
        duration: 1000,
        offset: 40,
        callback: undefined,
        a11y: false,
      })
    }
  }

  function handleNext() {
    setActiveStep(activeStep + 1 >= maxSteps ? 0 : activeStep + 1)
  }

  function handleBack() {
    setActiveStep(activeStep - 1 < 1 ? maxSteps - 1 : activeStep - 1)
  }

  function handleStepChange(step) {
    setActiveStep(step)
  }
  return (
    <>
      <section className={style.how_to_set_up}>
        <div className={style.text_wraper}>
          <h2 className={style.title}>Як налаштувати Apple Pay?</h2>
          <img
            src={AppleWallet}
            className={style.AppleWallet}
            alt="Таскомбанк AppleWallet Apple кошелек"
          />

          <SwipBox
            handleStepChange={handleStepChange}
            activeStep={activeStep}
          />
        </div>
        <Carousel
          handleNext={handleNext}
          handleBack={handleBack}
          handleStepChange={handleStepChange}
          activeStep={activeStep}
        />

        <div className={style.AppleWatch}>
          <div />
          <div className={style.AppleWatch_wraper}>
            <h3 className={style.AppleWatch_title} onClick={toogleInfo}>
              Як налаштувати Apple Watch ?
            </h3>
            <img
              style={{ backgroundColor: "transparent" }}
              src={AppleWatch}
              alt="Таскомбанк Apple Watch налаштування"
            />
          </div>
        </div>
      </section>
      {show ? <AnswerBox show={show} click={toogle} /> : null}
    </>
  )
}
export default Index
